import React from 'react';

// Components
import HeroSlider, {
    Slide,
    Overlay,
    MenuNav,
} from 'hero-slider';


const Slider = (props) => {
    return (
        <HeroSlider
            autoplay={true}
            orientation="horizontal"
            height='540px'
            style={{
                backgroundColor: '#00a86b',
                color: '#FFF',
            }}
            controller={{
                slidingDuration: 400,
                slidingDelay: 0,
                initialSlide: 1,
            }}
            manager={{
                isMobile: true
            }}
            animations={{
                slidingAnimation: "fade"
            }}
            settings={{
                shouldAutoplay: true,
                shouldDisplayButtons: false,
                autoplayDuration: 4000
            }}
        >
            <Overlay>
                <div className="textContent">
                    <h1>Welcome to</h1>
                    <h2>Dreis Space Limited</h2>
                    <h3>A fast growing IT solution provider</h3>
                </div>
            </Overlay>

            <Slide
                shouldRenderMask={false}
                label={(<><h4>ENGINEER</h4><p> devices, embedded, mobile, web, desktop, IoT and cloud solutions</p></>)}
                background={{
                    backgroundImageSrc: '/bg2.svg',
                    backgroundImageStyle: {
                        visibility: 'visible',
                    },
                    backgroundImageAlt: "NO IMAGE"
                }}
                onBackgroundLoad={{
                    shouldLazyLoad: true
                }}
            >
                <div className="slide__inner_top">
                    <img src='/wings.png' alt="wings.png" />
                </div>
                <div className="slide__inner_top">
                    <img src='/screw_middle.png' alt="screw_middle.png" />
                </div>
                <div className="slide__inner_bottom">
                    <img src="/drone_body.png" alt="drone_body.png" />
                </div>
            </Slide>
            <Slide
                shouldRenderMask={false}
                label={(<><h4>SCALE</h4><p>an MVP into a high-load system driven by an extendible architecture</p></>)}
                background={{
                    backgroundImageSrc: '/bg1.svg',
                    backgroundImageStyle: {
                        visibility: 'visible',
                    },
                    backgroundImageAlt: "NO IMAGE"
                }}

                onBackgroundLoad={{
                    shouldLazyLoad: false
                }}
            >
                <div className="slide__inner_bottom3 inner_ltr">
                    <img src="/slider-300.png" alt="slider-300.png"/>
                </div>
                <div className="slide__inner_bottom2 inner_rtl">
                    <img src="/slider-31.png" alt="slider-31.png"/>
                </div>
            </Slide>

            <Slide
                shouldRenderMask={false}
                label={(<><h4>TRANSFORM</h4><p>analog to digital, process automation, Big Data, сloud computing</p></>)}
                background={{
                    backgroundImageSrc: '/bg3.svg',
                    backgroundImageStyle: {
                        visibility: 'visible',
                        // backgroundPositionY: "25%",
                        // backgroundPositionX: "88%",
                        // backgroundSize: "inherit",
                        // backgroundRepeat: "no-repeat"
                    },
                    backgroundImageAlt: "NO IMAGE"
                }}

                onBackgroundLoad={{
                    shouldLazyLoad: false
                }}
            >
                <div className="slide__inner_left2">
                    <img src="/3D-printer2.png" alt="3D-printer2.png"/>
                </div>
                <div className="slide__inner_bottom3 slide3">
                    <img src="/3D-printer.png" alt="3D-printer.png"/>
                </div>
            </Slide>

            <MenuNav
                position={{
                    bottom: 0,
                    left: 0,
                    right: 0
                }}
            >
            </MenuNav>

        </HeroSlider>
    );
}

export default Slider;

